// FORM BUILDER ACTIONS:
export const SETWINDOWNAME="SETWINDOWNAME";
export const SELECTORUNSELECT="SELECTORUNSELECT";
export const DETAILVIEW_DRAG="DETAILVIEW_DRAG";
export const DRAG_ITEM_IN_MOBILEVIEW="DRAG_ITEM_IN_MOBILEVIEW";
export const DRAG_ITEM_IN_QUICKCREATE="DRAG_ITEM_IN_QUICKCREATE";
export const LAYOUT_SETTINGS = "LAYOUT_SETTINGS";
export const LAYOUT_FIELD_COUNT = 'LAYOUT_FIELD_COUNT';
export const ADD_ITEM_TO_PREVIEW = "ADD_ITEM_TO_PREVIEW";
export const REMOVE_ITEM_FROM_PREVIEW = "REMOVE_ITEM_FROM_PREVIEW";
export const DRAG_ITEM_IN_PREVIEW = "DRAG_ITEM_IN_PREVIEW";
export const SHOW_EDITOR = "SHOW_EDITOR";
export const HIDE_EDITOR = "HIDE_EDITOR";
export const SUBMIT_EDITOR_STATE = "SUBMIT_EDITOR_STATE";
export const ADD_FORM_TO_PREVIEW = "ADD_FORM_TO_PREVIEW";
export const ADD_SECTION_TO_PREVIEW = "ADD_SECTION_TO_PREVIEW";
export const SET_FORM_CONTENT = "SET_FORM_CONTENT";
export const DRAG_CONTENT_IN_PREVIEW = "DRAG_CONTENT_IN_PREVIEW";
export const UPDATE_SECTION_HEAD = "UPDATE_SECTION_HEAD";
export const REMOVE_SECTION ="REMOVE_SECTION";
export const LAYOUT_COLUMN_CHANGE = "LAYOUT_COLUMN_CHANGE";
export const UPDATE_LAYOUT_ONCHANGE="UPDATE_LAYOUT_ONCHANGE";
export const SET_LAYOUT_DATA="SET_LAYOUT_DATA";
export const SET_LAYOUT_DATA_SUBFORM="SET_LAYOUT_DATA_SUBFORM";
export const SET_MAPPING_TAGS = "SET_MAPPING_TAGS";
export const CLEAR_FIELD_GROUPS = "CLEAR_FIELD_GROUPS";
export const SET_EMAIL_CONFIG_LIST ="SET_EMAIL_CONFIG_LIST";
export const ADD_COPY_SECTION_TO_LAYOUT ="ADD_COPY_SECTION_TO_LAYOUT";
export const ADD_REMOVE_ITEM_TO_QUICK_CREATE ="ADD_REMOVE_ITEM_TO_QUICK_CREATE";
export const UPDATE_SECTION_SORT_BY = "UPDATE_SECTION_SORT_BY";
export const UPDATE_LAYOUT_DATA = "UPDATE_LAYOUT_DATA";

// FORM GENERATOR ACTIONS:
export const LOAD_DEMO = "LOAD_DEMO";
export const HIDE_DEMO = "HIDE_DEMO";
export const HANDLE_INPUT_CHANGE = "HANDLE_INPUT_CHANGE";
export const HANDLE_CHECKBOX_CHANGE = "HANDLE_CHECKBOX_CHANGE";
export const HANDLE_TAGS_CHANGE = "HANDLE_TAGS_CHANGE";
export const HANDLE_RADIOBUTTON_CHANGE = "HANDLE_RADIOBUTTON_CHANGE";
export const FORM_FIELD_VALIDATION="FORM_FIELD_VALIDATION";
export const UPDATE_FORM_FIELD_VALIDATION="UPDATE_FORM_FIELD_VALIDATION";
export const CLEAR_FORM_FIELD_VALIDATION="CLEAR_FORM_FIELD_VALIDATION";
 

export const ADD_SELECTED_MULTILOOKUP = "ADD_SELECTED_MULTILOOKUP";
export const REMOVE_SELECTED_MULTILOOKUP = "REMOVE_SELECTED_MULTILOOKUP";
export const CLEAR_SELECTED_MULTILOOKUP = "CLEAR_SELECTED_MULTILOOKUP";
export const SET_SELECTED_MULTILOOKUP = "SET_SELECTED_MULTILOOKUP";
export const DROPDOWN_FIELD_MAPPING = "DROPDOWN_FIELD_MAPPING";

export const DETAILVIEW_ADD = "DETAILVIEW_ADD";
export const DETAILVIEW_REMOVE = "DETAILVIEW_REMOVE";
export const DETAILVIEW_SORTING = "DETAILVIEW_SORTING";
export const DETAILVIEW_TYPE_HANDLER = "DETAILVIEW_TYPE_HANDLER";  
export const DETAILVIEW_SORT_BY_HANDLER = "DETAILVIEW_SORT_BY_HANDLER";  


export const SET_VALIDATION_RULES = "SET_VALIDATION_RULES";
export const SET_LAYOUT_RULES = "SET_LAYOUT_RULES";
export const SET_RULES_MAPPING = "SET_RULES_MAPPING";

export const FIELD_PERMISSION_ONCHANGE = "FIELD_PERMISSION_ONCHANGE";
export const MASTER_WINDOW_LIST_ACTION ="MASTER_WINDOW_LIST_ACTION";
// export const ON_CHANGE_FORM_INPUT = "ON_CHANGE_FORM_INPUT";

export const UPDATE_ACTION_BUTTON = "UPDATE_ACTION_BUTTON";

export const SET_SUBFORM_DATA = "SET_SUBFORM_DATA";
export const UPDATE_SUBFORM_DATA ="UPDATE_SUBFORM_DATA";
export const SET_LOOKUP_DEPENDENCY = "SET_LOOKUP_DEPENDENCY";
export const UPDATE_DETAIL_VIEW_STATUS = "UPDATE_DETAIL_VIEW_STATUS";

export const ADD_REMOVE_ITEM_TO_MOBILE_VIEW = "ADD_REMOVE_ITEM_TO_MOBILE_VIEW";
export const COPY_LAYOUT_FIELD_GROUPS = "COPY_LAYOUT_FIELD_GROUPS";
export const SET_ONCHANGE_DATA_VARIABLE_LIST = "SET_ONCHANGE_DATA_VARIABLE_LIST";


export const UPDATE_SUBFORM_FIELD_VALIDATION="UPDATE_SUBFORM_FIELD_VALIDATION";
export const ADD_INPROGRESS_STEP_EXECUTION = "ADD_INPROGRESS_STEP_EXECUTION";
export const REMOVE_INPROGRESS_STEP_EXECUTION = "REMOVE_INPROGRESS_STEP_EXECUTION";
export const CLEAR_SUBFORM_FIELD_VALIDATION = "CLEAR_SUBFORM_FIELD_VALIDATION";

export const SET_ONLOAD_DATA_CONFIG = "SET_ONLOAD_DATA_CONFIG";
export const SET_ONCHANGE_DATA_CONFIG = "SET_ONCHANGE_DATA_CONFIG";


export const SET_ONCHANGE_DATA_VARIABLE_LIST_QC = "SET_ONCHANGE_DATA_VARIABLE_LIST_QC";
export const SET_ONCHANGE_DATA_CONFIG_QC = "SET_ONCHANGE_DATA_CONFIG_QC";

export const HANDLE_INPUT_BLUR ="HANDLE_INPUT_BLUR";

//MYSHIP-HARDCODE
export const SET_CARRIER_SERVICES ="SET_CARRIER_SERVICES";
export const SET_FILE_ID ="SET_FILE_ID";